// utils/fechas.js
// Función para formatear fechas en formato DD/MM/AAAA ajustado a UTC-3 (Argentina)

export function formatearFechaArgentina(fecha) {
    // Si la fecha ya está en formato YYYY-MM-DD, úsala directamente
    if (typeof fecha === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(fecha)) {
        const [year, month, day] = fecha.split('-').map(Number);
        // Crear la fecha en UTC y sumar 3 horas
        const date = new Date(Date.UTC(year, month - 1, day, 3, 0, 0));
        // Mostrar como DD/MM/AAAA
        return `${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}/${year}`;
    }
    // Si es Date u otro formato, intentar ajustarlo
    try {
        const d = new Date(fecha);
        d.setHours(d.getHours() + 3);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
    } catch {
        return String(fecha);
    }
}

